export default __webpack_public_path__ + "static/IOT_plateform-a5006715806293cdde931e2021590734.png";